import { UPDATE_OFFSET } from "../actions/actionType";

const initialState = { offset: 1 };

export const updateOffset = (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_OFFSET:
      state = { offset: payload };
      return state;
    default:
      return state;
  }
};
